var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.errors && _vm.errors.length
    ? _c(
        "v-alert",
        {
          staticClass: "form-errors",
          attrs: { dense: "", outlined: "", type: "error" },
        },
        [
          _c("span", [_vm._v("Fix some errors")]),
          _c("br"),
          _vm._v(" "),
          _vm._l(_vm.errors, function (error) {
            return [
              _c(
                "span",
                [
                  _c("v-icon", { attrs: { color: "error" } }, [
                    _vm._v("mdi-circle-medium"),
                  ]),
                  _vm._v(_vm._s(error)),
                ],
                1
              ),
              _c("br"),
            ]
          }),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }